import script from "./title-text.vue?vue&type=script&setup=true&lang=js"
export * from "./title-text.vue?vue&type=script&setup=true&lang=js"

import "./title-text.vue?vue&type=style&index=0&id=125bb8ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125bb8ad"]])

export default __exports__